"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const extendTheme_1 = require("../extendTheme");
const lifeCycle_1 = require("../lifeCycle");
exports.theme = extendTheme_1.extendTheme(lifeCycle_1.theme, {
    name: 'humly',
    userFriendlyName: 'Humly',
    logo: require('./logo.png').default,
    dark: false,
    fontImports: [
        "@import url('https://fonts.googleapis.com/css?family=Zilla+Slab:300,300italic,regular,italic,500,500italic,600,600italic,700,700italic|Lato:100,100italic,300,300italic,regular,italic,700,700italic,900,900italic|Muli:200,300,regular,500,600,700,800,900,200italic,300italic,italic,500italic,600italic,700italic,800italic,900italic&subset=latin-ext,latin,vietnamese')",
    ],
    fonts: {
        heading: "'OCRey-demi','Zilla Slab','zilla-medium',Helvetica,Arial,Lucida,sans-serif",
        subheading: "'OCRey-demi','Zilla Slab','zilla-medium',Helvetica,Arial,Lucida,sans-serif",
        body: "'Lato','Zilla Slab','zilla-medium',Helvetica,Arial,Lucida,sans-serif",
        navigation: "'Zilla Slab','zilla-medium',Helvetica,Arial,Lucida,sans-serif",
    },
    colors: {
        selected: '#186A6B',
        pageText: '#111',
        install: {
            connected: '#87c144',
            expired: '#d70b0b',
            pending: '#186A6B',
            planned: '#555',
            skipped: '#fb0',
        },
        primary: '#fff',
        primaryDark: '#eee',
        primaryText: '#000',
        danger: '#d70b0b',
        muted: '#ccc',
        success: '#87c144',
        offline: '#d70b0b',
        info: '#186A6B',
        warning: '#daa520',
        online: '#87c144',
        accent: '#26B4B5',
        accentBackgroundedText: '#FFF',
        pageBackground: '#f6f6f6',
        cardBackground: '#fff',
        cardText: '#000',
        charts: {
            primary: '#26B4B5',
            max: '#f7b2bb',
            min: '#45D4D5',
            neutral: '#959595',
            intervalShade: '#ddd',
            grid: 'rgba(125,125,125,0.1)',
            axisTicks: 'rgba(125,125,125,0.2)',
            axisLine: 'rgba(125,125,125,0.2)',
        },
    },
});
//# sourceMappingURL=index.js.map